var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 0) scale(-2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.173 63.05 c -3.296 0 -5.978 -2.682 -5.978 -5.979 c 0 -3.296 2.682 -5.978 5.978 -5.978 c 3.296 0 5.978 2.682 5.978 5.978 C 18.151 60.368 15.469 63.05 12.173 63.05 z M 12.173 53.094 c -2.193 0 -3.978 1.784 -3.978 3.978 s 1.784 3.979 3.978 3.979 s 3.978 -1.785 3.978 -3.979 S 14.366 53.094 12.173 53.094 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.17 58.069 c -0.26 0 -0.52 -0.1 -0.7 -0.289 c -0.19 -0.19 -0.3 -0.44 -0.3 -0.711 c 0 -0.13 0.03 -0.26 0.08 -0.38 c 0.05 -0.12 0.12 -0.229 0.22 -0.33 c 0.37 -0.369 1.04 -0.369 1.41 0 c 0.09 0.101 0.16 0.21 0.22 0.33 c 0.05 0.12 0.07 0.25 0.07 0.38 c 0 0.271 -0.1 0.521 -0.29 0.711 C 12.69 57.97 12.44 58.069 12.17 58.069 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89 58.071 H 45.224 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 H 88 V 30.552 c 0 -0.883 -0.719 -1.602 -1.602 -1.602 H 3.602 C 2.718 28.951 2 29.669 2 30.552 V 54.47 c 0 0.883 0.718 1.602 1.602 1.602 h 3.594 c 0.552 0 1 0.447 1 1 s -0.448 1 -1 1 H 3.602 C 1.616 58.071 0 56.456 0 54.47 V 30.552 c 0 -1.986 1.616 -3.602 3.602 -3.602 h 82.797 c 1.986 0 3.602 1.616 3.602 3.602 v 26.519 C 90 57.624 89.553 58.071 89 58.071 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26.209 63.05 c -3.296 0 -5.978 -2.682 -5.978 -5.979 c 0 -3.296 2.682 -5.978 5.978 -5.978 c 3.296 0 5.978 2.682 5.978 5.978 C 32.187 60.368 29.505 63.05 26.209 63.05 z M 26.209 53.094 c -2.193 0 -3.978 1.784 -3.978 3.978 s 1.785 3.979 3.978 3.979 s 3.978 -1.785 3.978 -3.979 S 28.403 53.094 26.209 53.094 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26.21 58.069 c -0.27 0 -0.52 -0.1 -0.71 -0.289 c -0.19 -0.19 -0.29 -0.44 -0.29 -0.711 c 0 -0.13 0.03 -0.26 0.08 -0.38 c 0.05 -0.12 0.12 -0.229 0.21 -0.33 c 0.37 -0.369 1.05 -0.369 1.42 0 c 0.09 0.101 0.16 0.21 0.21 0.33 c 0.05 0.12 0.08 0.25 0.08 0.38 c 0 0.271 -0.1 0.521 -0.29 0.711 C 26.73 57.97 26.48 58.069 26.21 58.069 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.231 58.071 h -4.081 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 4.081 c 0.552 0 1 0.447 1 1 S 21.784 58.071 21.231 58.071 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82.514 63.05 h -2.147 c -0.553 0 -1 -0.447 -1 -1 v -4.979 c 0 -0.553 0.447 -1 1 -1 s 1 0.447 1 1 v 3.979 h 1.147 c 0.553 0 1 0.447 1 1 S 83.066 63.05 82.514 63.05 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40.246 63.05 c -3.296 0 -5.978 -2.682 -5.978 -5.979 c 0 -3.296 2.682 -5.978 5.978 -5.978 s 5.978 2.682 5.978 5.978 C 46.224 60.368 43.542 63.05 40.246 63.05 z M 40.246 53.094 c -2.193 0 -3.978 1.784 -3.978 3.978 s 1.785 3.979 3.978 3.979 s 3.978 -1.785 3.978 -3.979 S 42.439 53.094 40.246 53.094 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40.25 58.069 c -0.27 0 -0.52 -0.1 -0.71 -0.289 c -0.19 -0.19 -0.29 -0.44 -0.29 -0.711 c 0 -0.13 0.02 -0.26 0.07 -0.38 s 0.13 -0.229 0.22 -0.33 c 0.37 -0.369 1.04 -0.369 1.41 0 c 0.1 0.101 0.17 0.21 0.22 0.33 c 0.05 0.12 0.08 0.25 0.08 0.38 c 0 0.271 -0.11 0.521 -0.3 0.711 C 40.76 57.97 40.51 58.069 40.25 58.069 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35.268 58.071 h -4.081 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 4.081 c 0.552 0 1 0.447 1 1 S 35.82 58.071 35.268 58.071 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerIcon);
export default __webpack_public_path__ + "static/media/trailerIcon.aa556bdbdc52b04d04ae76d54d8410fb.svg";
export { ForwardRef as ReactComponent };